<template>
  <b-modal
    id="ushrUserSelectDRT"
    content-class="generic-release-modal drt-user-select"
    size="sm"
    hide-footer
    centered
    @show="initDRTUserSelect"
    @hide="handleClose"
  >
    <template #modal-header="{ close }">
      <div class="grm-header d-flex align-items-center w-100">
        <div class="grm-header-text">
          <h5 class="grm-title mb-0">Select a Customer</h5>
          <p class="grm-subtitle mb-0">DRT</p>
        </div>
        <div class="grm-header-badge ml-auto">
          {{ customers.length }} available
        </div>
        <!-- <button class="grm-close-btn" title="Close" @click="close()"> -->
        <fa :icon="['fas', 'times']" @click="close()" class="dataset-close-btn"/>
        <!-- </button> -->
      </div>
    </template>

    <div class="usc-list">
      <template v-for="c in customers">
        <div
          v-if="isUshrUser"
          :key="c.id"
          class="usc-item"
          @click="ushrUserDrtChange(c)"
        >
          <div class="usc-avatar">{{ c.name.charAt(0).toUpperCase() }}</div>
          <span class="usc-name">{{ c.name.substring(0, c.name.length - 4) }}</span>
          <svg class="usc-arrow" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </template>
      <div v-if="customers.length === 0" class="usc-empty">No customers available</div>
    </div>
  </b-modal>
</template>

<style>
/* Scoped to .drt-user-select so the sibling ANSI modal (which shares the
   global .usc-* classes) is unaffected. */
.drt-user-select .modal-body {
  background: linear-gradient(180deg, #ffffff 0%, #f3f8fc 100%);
}

.drt-user-select .usc-list {
  padding: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 62vh;
  overflow-y: auto;
}

.drt-user-select .usc-list::-webkit-scrollbar {
  width: 6px;
}
.drt-user-select .usc-list::-webkit-scrollbar-track {
  background: transparent;
}
.drt-user-select .usc-list::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.2);
  border-radius: 999px;
}

.drt-user-select .usc-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0.7rem 0.95rem;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid rgba(6, 60, 109, 0.1);
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(6, 60, 109, 0.05);
  overflow: hidden;
  animation: uscFadeIn 0.28s ease both;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

/* Accent bar that grows in on hover */
.drt-user-select .usc-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #0a548f, #063c6d);
  transform: scaleY(0);
  transition: transform 0.2s ease;
}

.drt-user-select .usc-item:hover {
  transform: translateY(-2px);
  border-color: rgba(6, 60, 109, 0.28);
  box-shadow: 0 8px 22px rgba(6, 60, 109, 0.15);
}

.drt-user-select .usc-item:hover::before {
  transform: scaleY(1);
}

.drt-user-select .usc-item:hover .usc-arrow {
  color: #063c6d;
  transform: translateX(4px);
}

.drt-user-select .usc-item:hover .usc-avatar {
  transform: scale(1.06);
  box-shadow: 0 4px 12px rgba(6, 60, 109, 0.32);
}

.drt-user-select .usc-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0a548f 0%, #063c6d 100%);
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 6px rgba(6, 60, 109, 0.25);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.drt-user-select .usc-name {
  flex: 1;
  font-size: 0.9rem;
  font-weight: 600;
  color: #063c6d;
  letter-spacing: 0.01em;
}

.drt-user-select .usc-arrow {
  width: 16px;
  height: 16px;
  color: rgba(6, 60, 109, 0.3);
  flex-shrink: 0;
  transition: color 0.18s ease, transform 0.18s ease;
}

.drt-user-select .usc-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: rgba(6, 60, 109, 0.4);
  font-size: 0.85rem;
}

@keyframes uscFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.drt-user-select .dataset-close-btn {
  color: whitesmoke;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.15s ease;
}

.drt-user-select .dataset-close-btn:hover {
  opacity: 0.75;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DRT_ushrUserSelectDRT',
  props: ['isUshrUser'],
  data() {
    return {
      // Customers are the project ids for DRT projects from the database
      customers: [],
      project_type: null,
      ushrUserSelectedDRT: undefined,
      // Tracks whether a customer was actually picked before the modal closes —
      // the parent also hides this modal programmatically right after a valid
      // selection, so @hide alone can't tell "user closed it" apart from that.
      selected: false
    }
  },
  methods: {
    initDRTUserSelect() {
      this.selected = false
      this.loadDrtProjects()
    },
    handleClose() {
      if (!this.selected) {
        this.$emit('returnHome')
      }
    },
    ushrUserDrtChange(customer) {
      this.selected = true
      this.$emit('datasetSelect', {
        customer: customer,
        project: 'Delivery Review Tool'
      })
    },
    loadDrtProjects() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/projects/ProjectIdForDRT', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.customers = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    }
  }
}
</script>
